import api from 'Application/api/api';

const signatureVerifyAuthenticityForDirectProcedure = (
    driverLicenseControlId,
    signature,
    cancelToken = null,
) => {
    const formData = new FormData();

    formData.append('signature', signature);

    return api.post(
        `/measures/vehicles/driver-licenses/controls/${driverLicenseControlId}/driver-license/direct-check/signature-verify-authenticity`,
        formData,
        { cancelToken },
    );
};

export default signatureVerifyAuthenticityForDirectProcedure;
